import { useMutation } from '@apollo/client';
import { ACCOUNT_GET_BREEDER_APPLICATIONS } from '@application/api/account/applications/useGetBreederApplications';
import { graphql } from '@gql/gql';
import type {
  MtApplicationsWaitlistApplicationMutation,
  MtApplicationsWaitlistApplicationMutationVariables,
  WaitlistApplicationInput,
} from '@gql/graphql';
import { useCallback } from 'react';

export const MT_APPLICATIONS_WAITLIST_APPLICATION = graphql(`
  mutation MtApplicationsWaitlistApplication($data: WaitlistApplicationInput!) {
    waitlistApplication(data: $data) {
      id
      status
    }
  }
`);

export const useWaitlistApplication = () => {
  const [waitlist, { loading }] = useMutation<
    MtApplicationsWaitlistApplicationMutation,
    MtApplicationsWaitlistApplicationMutationVariables
  >(MT_APPLICATIONS_WAITLIST_APPLICATION, {
    awaitRefetchQueries: true,
    refetchQueries: [ACCOUNT_GET_BREEDER_APPLICATIONS],
  });

  const waitlistApplication = useCallback(
    async (data: WaitlistApplicationInput) => {
      const app = await waitlist({
        variables: {
          data,
        },
      });

      return app.data;
    },
    [waitlist],
  );

  return {
    waitlistApplication,
    waitlistApplicationLoading: loading,
  };
};
